import { Component } from '@angular/core';

@Component({
  template: '<a-not-found></a-not-found>'
})
export class NotFoundPageComponent {}
